// Kept apart from the sorted imports below to preserve CSS cascade order.
import './playlist-player.scss';

import 'Modules/video/components/vm-video-card-related/vm-video-card-related';
import 'Modules/video/components/vm-video-hub-card/vm-video-hub-card';
import 'Modules/video/components/vm-video-hub-related/vm-video-hub-related';
import 'Modules/video/components/vm-video-related-content/vm-video-related-content';
import { trackPlaylistItemClicks } from './playlist-tracking';

trackPlaylistItemClicks();
